<div class="section">
    <h4 class="title">My WorkList Management</h4>
      <div class="row d-flex justify-content-end">
          <!-- <button class="btn btn-sm btn-dark mb-1 mt-1 mr-4" (click)="internal_allocation()">View Team Allocations</button> -->
      </div>
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <td>S.No</td>
            <td>BANK NAME</td>
            <td>Team NAME</td>
            <td>User Name</td>
            <td>User Bank</td>
  
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of rows; let i = index;">
            <td>{{i+1}}</td>
            <td>
              <select [(ngModel)]="item.Bank_id" class="form-control" disabled>
                <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}</option>
                </select>
            </td>
            <td>{{item.team_name}}</td>
            <td>{{item.member_user_id.name}}</td>
            <td>{{item.member_user_id.bankname}}</td>
            <td><button class="btn btn-sm btn-dark mb-1 mt-1 mr-4"  (click)="allocation_data(item.member_user_id._id)" >View allocation</button></td>
          </tr>
        </tbody>
      </table>
  </div>
  